import { amexMetrics } from './amexCaseStudy';
import { hotelplannerMetrics } from './hotelplannerCaseStudy';
import { mckinseyMetrics } from './mckinseyCaseStudy';
import { rsiMetrics } from './rsiCaseStudy';

export type Metric = { value: string; label: string };

/** Result metrics for each case study, keyed by case study id — shared by the detail pages and homepage cards. */
export const caseStudyMetrics: Record<string, Metric[]> = {
  rsi: rsiMetrics,
  hotelplanner: hotelplannerMetrics,
  amex: amexMetrics,
  mckinsey: mckinseyMetrics,
};
